<template>
  <div>

    <b-form-group  >
      <!--            <validation-provider-->
      <!--                #default="{ errors }"-->
      <!--                :name="fieldsData.name"-->
      <!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->

      <b v-if="fieldsData.fieldType =='TextView'&&fieldsData.visible==1" v-html="fieldsData.label[selectlang]"></b>


    </b-form-group>
  </div>
</template>

<script>
// import {ValidationProvider} from "vee-validate";
// import {required} from "@validations";
export default {
  components: {
    // ValidationProvider,
  },
  // props: {
  //   fieldsData: {
  //     // type: Object,
  //     // default: () => fieldsData,
  //   },
  // },
  data() {
    return {
      // errors: [],
      DataArray:{},
      // required,
    };
  },
  props: ['fieldsData','selectlang'],



  created() {

  },

  methods: {


  }
}
</script>

<style>
/* Add your styles here */
</style>
